module.exports = __webpack_public_path__ + "7395d27d07c6801763ed55c545432d51.jpg";